module.exports = __webpack_public_path__ + "img/gray-privilege.6c207f56.png";